module.exports = "/_next/static/images/status-waiting-44185a9c.png";